import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['settings', 'user'])
}



// WEBPACK FOOTER //
// ./src/layout/headers/menu/config/resources/computed.js